<template>
  <div>
    <div>
      <span class="xbed-sub-title">用户卡券管理</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>用户卡券列表</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='手机号' :label-width='100'>
        <Input type='text' v-model.trim="queryParams.phone" :maxlength="11" style="width:200px;"></Input>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="queryUserCouponListFn">查询</Button>
      </FormItem>

      <Content>
        <Table stripe :columns="columnsList" :data='couponlist' :loading='isloading'></Table>
      </Content>
    </Form>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
import moment from "moment";
import { phoneRegular } from '../../utils/regular'

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.userId = Utils.findFromLocalStorage("vue-userid");
    this.env = Utils.findFromLocalStorage("env", "dev");

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env),
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }

    if (!Utils.hasPermission('userCouponManage')) {
      this.$Notice.error({
        title: "无权限查看标签组"
      });
      return
    }
  },

  data() {
    return {
      operateloading: false,
      queryParams: {
        phone: ''
      },
      couponlist: [],
      isloading: false,
      columnsList: [
        {
          title: 'ID',
          key: 'id',
          align: 'center',
          width: 80
        },
        {
          title: '用户',
          align: 'center',
          width: 240,
          render: (h, params) => {
            let text = params.row.userId + '_' + params.row.phone
            return h("span", {}, text)
          }
        },
        {
          title: '优惠券码',
          key: 'cardId',
          align: 'center',
          width: 200
        },
        {
          title: '名称',
          key: 'title',
          align: 'center',
          width: 200
        },
        {
          title: '接收时间',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h("span", moment(params.row.receiveTimestamp).format("YYYY-MM-DD HH:mm:ss"))
          }
        },
        {
          title: '接收方式',
          align: 'center',
          key: 'couponCardSource',
          width: 80
        },
        // {
        //   title: '渠道编码',
        //   // key: 'orderNo',
        //   align: 'center',
        //   width: 280,
        //   render: (h, params) => {
        //     const type = params.row.otherOrderNo ? params.row.otherOrderNo : "-"
        //     return h('span', {}, type)
        //   }
        // },
        // {
        //   title: '实收',
        //   // key: 'realPrice',
        //   align: 'center',
        //   width: 280,
        //   render: (h, params) => {
        //     const type = params.row.otherRealPrice ? Math.round(Number(params.row.otherRealPrice) / 100).toFixed(2).toString() : "-"
        //     return h('span', {}, type)
        //   }
        // },
        // {
        //   title: '手动赠送',
        //   // key: 'sendCardNumber',
        //   align: 'center',
        //   width: 280,
        //   render: (h, params) => {
        //     const type = params.row.sendCardNumber ? params.row.sendCardNumber : "-"
        //     return h('span', {}, type)
        //   }
        // },
        {
          title: '核销券码',
          align: 'center',
          // key:'otherCardNo',
          width: 200,
          render: (h, params) => {
            // let text = params.row.otherCardNo ? params.row.otherCardNo : "-"
            // let text = `<p>渠道编号：${params.row.otherOrderNo ? params.row.otherOrderNo : "-"}</p>
            // <p>实收：${params.row.otherRealPrice ? Math.round(Number(params.row.otherRealPrice) / 100).toFixed(2).toString() : "-"}</p>
            // <p>手动赠送:${params.row.sendCardNumber ? params.row.sendCardNumber : "-"}</p>
            // `
            // if (params.row.otherCardNo === 0 ) {
            //   text = '未使用'
            // } else if (params.row.cardStat === 1 ) {
            //   text = '使用中'
            // } else if (params.row.cardStat === 2 ) {
            //   text = '已使用'
            // } else {
            //   text = '已作废'
            // }
            return h('div', {}, [
              h('p',{},`渠道编号：${params.row.otherOrderNo ? params.row.otherOrderNo : "-"}`),
              h('p',{},`实收：${params.row.otherRealPrice ? Math.round(Number(params.row.otherRealPrice) / 100).toFixed(2).toString() : "-"}`),
              h('p',{},`赠送数量:${params.row.sendCardNumber ? params.row.sendCardNumber : "-"}`)
            ])
          }
        },
        {
          title: '送券备注',
          align: 'center',
          width: 400,
          render: (h, params) => {
            if (params.row.couponCardSource === '手动派发') {
              return h('span', {}, '【' + (params.row.sendRewardOperator ? params.row.sendRewardOperator : '-') + '】' + (params.row.sendRewardRemark ? params.row.sendRewardRemark : '-'))
            } else {
              return h('span', {}, '-')
            }
          }
        },
        {
          title: '状态',
          align: 'center',
          width: 70,
          render: (h, params) => {
            let text = '-'
            if (params.row.cardStat === 0) {
              text = '未使用'
            } else if (params.row.cardStat === 1) {
              text = '使用中'
            } else if (params.row.cardStat === 2) {
              text = '已使用'
            } else {
              text = '已作废'
            }
            return h('span', {}, text)
          }
        },
        {
          title: '使用订单',
          align: 'center',
          width: 200,
          render: (h, params) => {
            if (params.row.cardStat === 2) {
              return h(
                "a",
                {
                  on: {
                    click: () => {
                      if (this.$router) {
                        this.$router.push({ path: "/app/order/orderDetail", query: { orderNo: params.row.orderNo } });
                      } else {
                        window.open(`#/Order/Reserve/newOrderDetailView?orderNo=${params.row.orderNo}`);
                      }
                    }
                  }
                },
                params.row.orderNo
              );
            } else {
              return h('span', {}, '-')
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 80,
          render: (h, params) => {
            if (params.row.cardStat === 0) {
              return h('Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      console.log('test=======')
                      if (!Utils.hasPermission('couponLeft')) {
                        this.$Notice.error({
                          title: "无权限操作"
                        });
                        return
                      }
                      this.$Modal.confirm({
                        title: '作废优惠券',
                        content: '该用户优惠券作废后不可使用，确认作废？',
                        okText: '确定作废',
                        cancelText: '取消',
                        onOk: () => {
                          this.abandonCouponFn(params.row.id)
                        }
                      })
                    }
                  }
                }, '作废')
            } else {
              return h('span', {}, '不可操作')
            }
          }
        }
      ]
    }
  },

  mounted() {
    this.$Notice.config({
      top: 200
    });
  },

  methods: {
    async queryUserCouponListFn() {
      try {
        let phoneAvail = phoneRegular.test(this.queryParams.phone.trim())
        if (!phoneAvail) {
          this.$Notice.error({
            title: '请输入正确的手机号',
          })
          return
        }
        let resp = (await API.omsAPI[this.env].clientServer.getUserCouponlist(this.queryParams.phone.trim(), this.protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取用户卡券列表数据异常',
            desc: resp.msg
          })
          return
        }

        this.couponlist = resp
      } catch (e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    async abandonCouponFn(couponId) {
      try {
        let params = {
          id: couponId,
          flag: true,
          operator: this.username
        }
        let resp = (await API.omsAPI[this.env].clientServer.updateCouponCard(params, this.protHeaders)).data;
        this.operateloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '本次操作请求异常',
            desc: resp.msg
          })
          return
        }

        this.$Notice.success({
          title: '已成功作废该卡券',
        })
        this.queryUserCouponListFn()
      } catch (e) {
        this.operateloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/marketing/userCouponManage.vue